import React from 'react';
import { NetworkInsights } from '@frontend/gql/social/graphql';
import { Card } from '@frontend/shadcn/components/ui/card';
import { InstagramIcon } from '@revfluence/fresh-icons/brands/esm';
import {
  TableHeader as TableHeaderComponent,
  TableHeaderSection,
  TableHeaderLayout,
  TableHeaderLabel,
} from '../table-header';
import { NetworkMetricsTable } from '../network-metrics-table';

interface InstagramMetricsCardProps {
  data?: NetworkInsights | null;
  socialDataReconciliation?: boolean;
}

export const InstagramMetricsCard = ({ data, socialDataReconciliation }: InstagramMetricsCardProps) => {
  return (
    <Card aria-label="Instagram Metrics">
      <TableHeaderComponent>
        <TableHeaderLayout>
          <TableHeaderSection>
            <TableHeaderLabel>
              <div className="flex items-center gap-2">
                <InstagramIcon className="h-5 w-5 [&>path]:fill-[url(#instagram-gradient)]" />
                <svg width="0" height="0">
                  <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#833AB4" />
                    <stop offset="50%" stopColor="#FD1D1D" />
                    <stop offset="100%" stopColor="#F77737" />
                  </linearGradient>
                </svg>
                <span aria-live="polite">Instagram</span>
              </div>
            </TableHeaderLabel>
          </TableHeaderSection>
        </TableHeaderLayout>
      </TableHeaderComponent>
      <NetworkMetricsTable data={data} socialDataReconciliation={socialDataReconciliation} />
    </Card>
  );
};
